<template>
  <div class="about">
    <div><p style="text-align: right;">{{shop}}</p></div>
    <h1>Contact Us</h1>
    <section>
      <div class="faq-container">
        <div class="question">
          <h4>Contact us</h4>
          <div class="content">If you have any query, please contact us at <a href="mailto:support@inscoder.com">support@inscoder.com</a></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  computed: {
    count () {
      return this.$store.state.count
    }
  },
  created: function () {

  },
  data () {
    return {
      shop: this.$store.state.shop,
      info: null,
      loading: true,
    }
  },
  filters: {
    currencydecimal (value) {
      return value.toFixed(2)
    }
  },
  mounted () {

  }

}
</script>
